import { filter, first, map, merge, startWith, Subject, switchMap } from 'rxjs';
import { getCookie, getData, metricsLog, setData } from './utils';
import { PixelsVideoEvent } from '../../constants/Video';

const videoOrderProvider = () => {
  let videoPosition = 0;
  return ([eventType]: string[]) => {
    switch (eventType) {
      case PixelsVideoEvent.INIT:
        videoPosition = 1;
        return videoPosition;
      default:
        videoPosition += 1;
        return videoPosition;
    }
  };
};

export const runningOrderPosition = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {

  const prerollStarted$ = sub.pipe(
    filter(([type]) => [
      PixelsVideoEvent.AD_STARTED
    ].includes(type as PixelsVideoEvent)),
    filter(([, { adPos }]) => adPos === 'pre')
  );

  const firstFrame$ = sub.pipe(
    filter(([type]) => [
      PixelsVideoEvent.FIRST_FRAME
    ].includes(type as PixelsVideoEvent)),
  );

  const switchVideo$ = sub.pipe(
      filter(([type]) => [
        PixelsVideoEvent.VIDEO_ENDED
      ].includes(type as PixelsVideoEvent)),
      switchMap(() =>
        merge(prerollStarted$, firstFrame$).pipe(
          first()
        )
      ),
      startWith([PixelsVideoEvent.INIT]),
      map(videoOrderProvider()),
    );

  switchVideo$.subscribe((value: number) => {
    const uuid = getCookie(pixelsUUIDKey);
    const storageKey = `${uuid}-${typeOfIntegration}`;
    const data = getData(storageKey);

    metricsLog(`Video order position: ${value}`);

    setData(storageKey, {
      ...data,
      running_order_position: {
        value
      }
    });
  });
};